import {
  Authority,
  RuleFactory,
  RawRuleOf,
  defineAbilityFor,
  AccessTokenData,
  useAbility as rawUseAbility,
  Subject,
  Ability,
} from '@modifi/plugin-authorization'
import {
  CONFIG_KEY_AUTH_TOKEN_SCOPE,
  CONFIG_KEY_AUTH_TOKEN_AUTHORITIES,
  CONFIG_KEY_AUTH_USER_NAME,
} from '@modifi/plugin-authentication'
import {clientConfig} from '@modifi/client-config'
import {TRANSACTION_LIST, TRANSACTION_DETAILS, TRANSACTION} from './section'

type Abilities =
  | ['read', Subject]
  | ['create' | 'delete' | 'update' | 'match', 'Transaction' | Subject]

type AppAbility = Ability<Abilities>

type Rule = RawRuleOf<AppAbility>

const TRANSACTIONS_READ_COMMON: RuleFactory<Rule> = () => [
  {
    action: ['read'],
    subject: TRANSACTION_LIST,
  },
  {
    action: ['read'],
    subject: TRANSACTION_DETAILS,
  },
]

const TRANSACTIONS_WRITE_COMMON: RuleFactory<Rule> = () => [
  {
    action: ['create', 'update', 'delete', 'match'],
    subject: TRANSACTION,
  },
]

const AUTHORITY_PERMISSIONS_MAP = new Map<Authority, RuleFactory<Rule>>([
  ['transactions:read:common', TRANSACTIONS_READ_COMMON],
  ['transactions:write:common', TRANSACTIONS_WRITE_COMMON],
])

const SCOPE_PERMISSION_MAP = new Map()

export const abilityFactory = (): AppAbility => {
  const user: AccessTokenData = {
    userName: clientConfig.get(CONFIG_KEY_AUTH_USER_NAME, '') as string,
    scope: clientConfig.get(CONFIG_KEY_AUTH_TOKEN_SCOPE, []) as string[],
    authorities: clientConfig.get(CONFIG_KEY_AUTH_TOKEN_AUTHORITIES, []) as string[],
  }

  return defineAbilityFor<Abilities>(
    user,
    {},
    {authorityPermissions: AUTHORITY_PERMISSIONS_MAP, scopePermissions: SCOPE_PERMISSION_MAP}
  )
}

export const useAbility = (): AppAbility => rawUseAbility<AppAbility>()
